module.exports = __webpack_public_path__ + "img/rons_broken_wand.03c017bf.jpg";